export default "__VITE_ASSET__LMVVwmiV__"